import React, { useState, useEffect, useRef } from 'react';

import { Modal } from 'flowbite';

import EvaluationTemplateListTableRow from './EvaluationTemplateListTableRow';

import { generateKey } from 'Helpers/misc';
import { modalOptions } from 'Helpers/modalOptions';

import ConfirmationModal from 'CommonComponents/ConfirmationModal';
import PaginationInfo from 'CommonComponents/PaginationInfo';
import TablePagination from 'CommonComponents/TablePagination';

export default function EvaluationTemplateListTable(props) {
    const [templates, setTemplates] = useState([]);
    const [perPage, setPerPage] = useState(25);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [to, setTo] = useState(1);
    const [from, setFrom] = useState(1);
    const [total, setTotal] = useState(1);
    const [isLoading, setIsLoading] = useState(1);

    // Const Delete Evaluation Template Confirmation

    const [deletedEvaluation, setDeletedEvaluation] = useState(null);
    const [deletedEvaluationModalElement, setDeletedEvaluationModalElement] = useState(null);
    const deletedEvaluationModalRef = useRef();

    const [actionCompleted, setActionCompleted] = useState(false);
    const [actionInProgress, setActionInProgress] = useState(false);
    const [actionFailed, setActionFailed] = useState(false);

    useEffect(() => {
        fetchTemplates();
        deletedEvaluationModalRef && setDeletedEvaluationModalElement(new Modal(deletedEvaluationModalRef.current, modalOptions(false)));
    }, []);

    const defaultUrl = props.fetchUrl + '?per_page=' + perPage;

    // Use Effect Delete Evaluation Template Confirmation

    useEffect(() => {
        if (deletedEvaluation) {
            deletedEvaluationModalElement && deletedEvaluationModalElement.show();
        }
    }, [deletedEvaluation]);

    const clickUrl = (template) => {
        let url = template.status > 0 ? props.summaryUrl : props.editUrl;
        url = url.replace('TEMPLATE_UUID', template.uuid);

        return url;
    };

    const combineFetchUrl = (p = null, pp = null) => {
        return props.fetchUrl + '?per_page=' + (pp || perPage) + '&page=' + (p || page);
    };

    const fetchTemplates = (url = null) => {
        setIsLoading(true);
        const fetchUrl = url || defaultUrl;

        axios
            .untranslated()
            .get(fetchUrl)
            .then((res) => {
                const { data, to, from, total, last_page } = res.data;
                setTemplates(data);
                setTo(to);
                setFrom(from);
                setTotal(total);
                setLastPage(last_page);
            })
            .catch((error) => {
                setTemplates([]);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    function pageChange(data) {
        const url = combineFetchUrl(data.selected + 1);
        setPage(+data.selected + 1);
        fetchTemplates(url);
    }

    // Functions Delete Evaluation Template Confirmation

    const confirmDeletedEvaluation = (evaluation) => {
        setDeletedEvaluation(null);
        setDeletedEvaluation(evaluation);
    };

    const successDeleteTemplateHandler = () => {
        const url = combineFetchUrl(page);
        fetchTemplates(url);

        deletedEvaluationModalElement && deletedEvaluationModalElement.hide();
        setDeletedEvaluation(null);
    };

    const closeDeleteTemplateHandler = () => {
        deletedEvaluationModalElement && deletedEvaluationModalElement.hide();
        setDeletedEvaluation(null);
    };

    const triggerDeleteEvaluation = () => {
        setActionInProgress(true);

        const url = props.deleteUrl.replace('TEMPLATE_UUID', deletedEvaluation.uuid);

        axios
            .delete(url)
            .then((response) => {
                setActionCompleted(true);
            })
            .catch((e) => {
                setActionFailed(true);
            })
            .finally(() => {
                setActionInProgress(false);
            });
    };

    const cleanConfirmationModalStates = () => {
        setActionInProgress(false);
        setActionFailed(false);
        setActionCompleted(false);
    };

    return (
        <>
            <div className="table__card">
                <div className="tw-mb-6">
                    <h5 className="table__header">{$t('Evaluation Template List')}</h5>
                    <div className="tw-flex tw-items-center tw-space-x-3">
                        <PaginationInfo to={to} from={from} total={total} />
                        <TablePagination lastPage={lastPage} pageChange={pageChange} />
                    </div>
                </div>
                <div className="inbud-table_wrapper">
                    <table className="inbud-table">
                        <thead>
                            <tr>
                                <th>{$t('Name')}</th>
                                <th>{$t('Status')}</th>
                                <th>{$t('Companies number')}</th>
                                <th>{$t('Scorers number')}</th>
                                <th>{$t('Created at')}</th>
                                <th>{$t('Actions')}</th>
                            </tr>
                        </thead>
                        {!isLoading && templates.length > 0 && (
                            <tbody>
                                {templates.map((template) => {
                                    return (
                                        <EvaluationTemplateListTableRow
                                            key={generateKey()}
                                            template={template}
                                            clickUrl={clickUrl(template)}
                                            deleteClick={() => confirmDeletedEvaluation(template)}
                                        />
                                    );
                                })}
                            </tbody>
                        )}
                        {isLoading && (
                            <tbody>
                                <tr>
                                    <td colSpan="5">{$t('Loading')}...</td>
                                </tr>
                            </tbody>
                        )}
                        {!isLoading && templates.length === 0 && (
                            <tbody>
                                <tr>
                                    <td colSpan="6">
                                        <a className="tw-italic" href={props.suppliersCreateUrl}>
                                            {$t('No Templates found. Click here to Add New Evaluation Template')}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
            <ConfirmationModal
                successHandler={successDeleteTemplateHandler}
                closeHandler={closeDeleteTemplateHandler}
                triggerAction={triggerDeleteEvaluation}
                cleanStates={cleanConfirmationModalStates}
                allowAction={deletedEvaluation !== undefined}
                modalId={`delete-Evaluation-${deletedEvaluation?.id}`}
                modalRef={deletedEvaluationModalRef}
                modalElement={deletedEvaluationModalElement}
                request={actionInProgress}
                actionCompleted={actionCompleted}
                actionFailed={actionFailed}
                confirmationMsg={$t('Are you sure you want to delete this evaluation: "{{name}}"?', { name: deletedEvaluation?.name })}
                actionCompletedMsg={$t('[{{name}}] deleted', { name: deletedEvaluation?.name })}
                actionFailedMsg={$t('The evaluation could not be deleted')}
                title={$t('Delete Evaluation')}
                cancelButtonText={$t('Close')}
                primaryButtonText={$t('Delete')}
            />
        </>
    );
}
